import { useState, useEffect } from 'react';
import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from 'lexical';
import { useRichTextEditor } from '../RichTextEditorProvider';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { TextUnderline } from '@sweep-io/sweep-design/dist/icons';

export const UnderlineButton = () => {
  const { editor } = useRichTextEditor();
  const [isUnderline, setIsUnderline] = useState(false);

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }: any) => {
      editorState.read(() => {
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          setIsUnderline(selection.hasFormat('underline'));
        }
      });
    });
  }, [editor]);

  return (
    <Tooltip title="Underline (Ctrl+U)">
      <IconButton
        variant="squared"
        size="small"
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
        }}
        pressed={isUnderline}
      >
        <TextUnderline />
      </IconButton>
    </Tooltip>
  );
};
